import { render, staticRenderFns } from "./speechDetails.vue?vue&type=template&id=31cbfcee&scoped=true&"
import script from "./speechDetails.vue?vue&type=script&lang=js&"
export * from "./speechDetails.vue?vue&type=script&lang=js&"
import style0 from "./speechDetails.vue?vue&type=style&index=0&id=31cbfcee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31cbfcee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCol,VImg,VRow,VSheet})
